import { APIModel } from '@shared/interfaces';
import { PollingStatus, StatusProvider } from '@/tax/models';

export class VATImport implements APIModel {
    id = -1;
    periodId = -1;
    reconciliationId = 1;
    status: PollingStatus = PollingStatus.Init;
    statusMessage?: string;
    statusMessageProvider?: StatusProvider;
    statusData?: { skipped?: { name: string; reason: string }[] };
    progress = 0;
    progressMessage?: string;

    deserialize(data: any): this {
        this.id = data.id ?? -1;
        this.periodId = data.period_id ?? -1;
        this.reconciliationId = data.reconciliation_id ?? 1;
        this.status = data.status ?? PollingStatus.Init;
        this.statusMessage = data.status_message ?? undefined;
        this.statusMessageProvider = data.status_message_provider ?? undefined;
        this.statusData = data.status_data ?? undefined;
        this.progress = data.progress ?? 0;
        this.progressMessage = data.progress_message ?? undefined;
        return this;
    }

    serialize(): any {
        const payload: any = {};
        (payload as any)['period_id'] = this.periodId;
        (payload as any)['reconciliation_id'] = this.reconciliationId;
        return payload;
    }
}

export interface ManualVatFile {
    id: number | null;
    name: string;
    fileType: 'VAT' | 'SALDO' | 'UNKNOWN';
    uploadedAt: string | null; // ISO string
    status: 'uploaded' | 'skipped';
    reason?: string;
}
